import AppRoute from "models/AppRoute"

const NoAccessRoute = new AppRoute({
    route: "/no-access",
    exact: true,
})

export default NoAccessRoute
